import { SelectOption } from '~/shared/utils/types';
import CloseIcon from '~/shared/assets/icons/close.svg';

export function FilterTag({ filter, onClose }: { filter: SelectOption; onClose: VoidFunction }) {
  const entitiesMap: Record<SelectOption['group'], string> = {
    volumeId: 'Volume ID',
    instanceId: 'Instance ID',
    monitoring: 'Monitoring Status',
    diskType: 'Type',
  };

  return (
    <div className="px-[12px] py-[8px] rounded-[8px] bg-[#4F75F6] text-white flex gap-[24px] items-center h-[48px]">
      <div className="text-[16px] font-semibold leading-[24px]">
        {filter?.group ? entitiesMap[filter?.group] : ''} <span className="font-normal">is</span>{' '}
        {filter?.name}
      </div>
      <button onClick={onClose}>
        <CloseIcon className="w-[12px] h-[12px] fill-white" />
      </button>
    </div>
  );
}
